import { Simulado } from '../@types';
import Service from './Service';

class QuestaoSimuladoService extends Service {
  static getQuestoesSimulado(simuladoId : string) {
    return this.Http.get<Simulado.QuestaoSimulado[]>(
      `/questionsmocktests/${simuladoId}`
    ).then(this.getData);
  }

  static getQuestaoSimulado(id: string) {
    return this.Http.get<Simulado.QuestaoSimulado>(
      `/questionsmocktests/${id}`
    ).then(this.getData);
  }

  static delete(id: string) {
    return this.Http.delete<any>(
      `/questionsmocktests/${id}`
    ).then(this.getData);
  }

  static inserirNovaQuestaoSimulado(simulado: Simulado.QuestaoSimulado) {
    return this.Http.post<Simulado.QuestaoSimulado>(
      '/questionsmocktests',
      simulado
    ).then(this.getData);
  }

  static inserirMuitas(simulado: Simulado.QuestaoSimulado) {
    return this.Http.post<Simulado.QuestaoSimulado[]>(
      '/questionsmocktests/mocktest',
      simulado
    ).then(this.getData);
  }
}

export default QuestaoSimuladoService;
